import { FilterCategory, FilterOption } from './Filter';

export const DEFAULT_COMPONENT_TYPE = 'default';
export const DATE_PICKER_RANGE_TYPE = 'date-picker-range';
export const DROPDOWN_CHECKBOX_TYPE = 'dropdown-checkbox';

// License Filter category
const defaultLicense: FilterOption = {
  id: 'default',
  categoryId: 'license',
  description: '',
  queryKey: '',
  componentType: DEFAULT_COMPONENT_TYPE,
};

export const licenseCategory: FilterCategory = {
  id: 'license',
  type: 'singular',
  defaultOption: defaultLicense,
  options: [defaultLicense],
};

// Subagent Filter category
const defaultSubagent: FilterOption = {
  id: 'default',
  categoryId: 'subagent',
  description: '',
  queryKey: '',
  componentType: DEFAULT_COMPONENT_TYPE,
};

export const subagentCategory: FilterCategory = {
  id: 'subagent',
  type: 'singular',
  defaultOption: defaultSubagent,
  options: [defaultSubagent],
};

// Date Filer Category
// note that date catgory filter options need the queryKeys to be
// dynamically generated as the current date.
export const defaultDate: FilterOption = {
  id: 'default',
  categoryId: 'date',
  description: 'Todas',
  daysOffsets: {
    start: undefined,
    end: undefined,
  },
  componentType: DEFAULT_COMPONENT_TYPE,
};

export const rangeDate: FilterOption = {
  id: 'range-date',
  categoryId: 'date',
  description: 'Personalizado',
  dates: {
    start: undefined,
    end: undefined,
  },
  componentType: DATE_PICKER_RANGE_TYPE,
};

export const dateToday: FilterOption = {
  id: 'date-today',
  categoryId: 'date',
  description: 'Hoy',
  daysOffsets: {
    start: 0,
    end: 1,
  },
  componentType: DEFAULT_COMPONENT_TYPE,
};

export const dateYesterday: FilterOption = {
  id: 'date-yesterday',
  categoryId: 'date',
  description: 'Ayer',
  daysOffsets: {
    start: -1,
    end: 0,
  },
  componentType: DEFAULT_COMPONENT_TYPE,
};

export const dateLastSevenOption: FilterOption = {
  id: 'date-last-seven',
  categoryId: 'date',
  description: 'Últimos 7 días',
  daysOffsets: {
    start: -7,
    end: 1,
  },
  componentType: DEFAULT_COMPONENT_TYPE,
};

export const dateLastFifteenOption: FilterOption = {
  id: 'date-last-fifteen',
  categoryId: 'date',
  description: 'Últimos 15 días',
  daysOffsets: {
    start: -15,
    end: 1,
  },
  componentType: DEFAULT_COMPONENT_TYPE,
};

export const dateLastThirtyOption: FilterOption = {
  id: 'date-last-thirty',
  categoryId: 'date',
  description: 'Últimos 30 días',
  daysOffsets: {
    start: -30,
    end: 1,
  },
  componentType: DEFAULT_COMPONENT_TYPE,
};

export const dateCategory: FilterCategory = {
  id: 'date',
  type: 'singular',
  defaultOption: defaultDate,
  options: [
    rangeDate,
    dateToday,
    dateYesterday,
    dateLastSevenOption,
    dateLastFifteenOption,
    dateLastThirtyOption,
    defaultDate,
  ],
};

// Plan Filter Category
const planDefault: FilterOption = {
  id: 'default',
  categoryId: 'plan',
  description: 'CC Individual',
  queryKey: 'individual',
  componentType: DEFAULT_COMPONENT_TYPE,
};

const planIndividual: FilterOption = {
  id: 'individual',
  categoryId: 'plan',
  description: 'CC Individual',
  queryKey: 'individual',
  componentType: DEFAULT_COMPONENT_TYPE,
};

const planRetention: FilterOption = {
  id: 'retention',
  categoryId: 'plan',
  description: 'CC Retención',
  queryKey: 'retencion',
  componentType: DEFAULT_COMPONENT_TYPE,
};

const planColective: FilterOption = {
  id: 'colective',
  categoryId: 'plan',
  description: 'CC Colectivas',
  queryKey: 'colectiva',
  componentType: DEFAULT_COMPONENT_TYPE,
};

export const planCategory: FilterCategory = {
  id: 'plan',
  type: 'singular',
  defaultOption: planDefault,
  options: [planIndividual, planRetention, planColective, planDefault],
};

// Origin Filter Category
const originDigital: FilterOption = {
  id: 'digital',
  categoryId: 'origin',
  description: 'Emisor web',
  queryKey: 'EMISORWEBAUTO,SOATWEB',
  componentType: DEFAULT_COMPONENT_TYPE,
};

const originCalculator: FilterOption = {
  id: 'calculator',
  categoryId: 'origin',
  description: 'Calculadora',
  queryKey: 'CALCULADORA',
  componentType: DEFAULT_COMPONENT_TYPE,
};

export const originCategory: FilterCategory = {
  id: 'origin',
  type: 'multiple',
  options: [originDigital, originCalculator],
};

// Status Filter Category
export const statusInspection: FilterOption = {
  id: 'inspection',
  categoryId: 'status',
  description: 'Por inspección',
  queryKey: '1',
  componentType: DEFAULT_COMPONENT_TYPE,
};

export const statusEmitting: FilterOption = {
  id: 'emission',
  categoryId: 'status',
  description: 'Por emisión',
  queryKey: '2',
  componentType: DEFAULT_COMPONENT_TYPE,
};
const statusProcessing: FilterOption = {
  id: 'processing',
  categoryId: 'status',
  description: 'En proceso',
  queryKey: '3',
  componentType: DEFAULT_COMPONENT_TYPE,
};

export const statusEmitted: FilterOption = {
  id: 'emitted',
  categoryId: 'status',
  description: 'Emitidas',
  queryKey: '4',
  componentType: DEFAULT_COMPONENT_TYPE,
};

const statusExpired: FilterOption = {
  id: 'expired',
  categoryId: 'status',
  description: 'Vencidas',
  queryKey: '',
  componentType: DEFAULT_COMPONENT_TYPE,
};

export const statusCategory: FilterCategory = {
  id: 'status',
  type: 'multiple',
  options: [
    statusInspection,
    statusEmitting,
    statusProcessing,
    statusEmitted,
    statusExpired,
  ],
};

export const currentUser = (userID = 'emptyUserID'): FilterOption => {
  return {
    id: userID,
    categoryId: 'user',
    description: userID,
    queryKey: userID,
    componentType: DEFAULT_COMPONENT_TYPE,
  };
};

export const userCategory = (userID: string | undefined): FilterCategory => ({
  id: 'user',
  type: 'multiple',
  defaultOption: undefined,
  options: [currentUser(userID)],
});

export function createFilterCategory(
  userID: string | undefined,
): FilterCategory[] {
  return [
    licenseCategory,
    subagentCategory,
    userCategory(userID),
    dateCategory,
    planCategory,
    originCategory,
    statusCategory,
  ];
}
